<template>
  <div>
    <div class="mt-4 px-4" v-if="isAdmin">
      <v-text-field
        label="Optional Student ID"
        v-model="studentID"
      ></v-text-field>
      <v-text-field label="Surname" v-model="lname"></v-text-field>
      <v-text-field label="First Names" v-model="fname"></v-text-field>
      <v-text-field label="Grade eg 08" v-model="grade"></v-text-field>
      <SelectClassComponent
        @selected-class="setSelectedClass"
        class="mb-4"
      ></SelectClassComponent>
      <v-row class="mb-4 mx-0">
        <v-btn
          class="my-4"
          :color="getThemeColor"
          @click="addStudentManual()"
          dark
        >
          <v-icon left>mdi-account-plus</v-icon>Add Student
        </v-btn>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/plugins/axios";
import SelectClassComponent from "@/components/GeneralComponents/SelectClassComponent.vue";

export default {
  computed: mapGetters(["isAdmin", "getAccessToken", "getThemeColor"]),
  components: { SelectClassComponent },
  data: () => ({
    studentID: null,
    lname: null,
    fname: null,
    grade: null,
    selectedClass: null,
    nameRules: [(v) => !!v || "Field is required"],
  }),
  methods: {
    setSelectedClass(selectedClass) {
      this.selectedClass = selectedClass;
    },
    addStudentManual() {
      if (
        this.selectedClass != null &&
        this.lname != null &&
        this.fname != null &&
        this.grade != null
      ) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/add-student-manual",
            {
              lname: this.lname,
              fname: this.fname,
              grade: this.grade,
              stuClass: this.selectedClass,
              studentID: this.studentID,
            },
            this.getAccessToken
          )
          .then((studentsData) => {
            this.$toast.success("Student Successfully Added!", {
              duration: 3000,
            });
            this.fname = null;
            this.lname = null;
            this.grade = null;
            this.$emit("student-added", studentsData);
          });
        this.$store.commit("setLoader", false);
      } else {
        alert("All Fields Are Required!");
      }
    },
  },
};
</script>
